<template>
  <div>
    <section class="section is-title-bar">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Upload documents</p>
          </div>
        </div>
      </div>
    </section>

    <section class="container section page-header section is-main-section">
      <card-component>
        <div class="columns">
          <div class="column">
            Staff Name:
            <span class="subtitle"> {{ user.firstName }} {{ user.lastName }}</span>
          </div>
          <div class="column">
            Staff Email Id:
            <span class="subtitle"> {{ user.email }}</span>
          </div>
          <div class="column"></div>
        </div>
      </card-component>
    </section>

    <section class="container section page-header section is-main-section">
      <form autocomplete="off" @submit.prevent="save">
        <div>
          <card-component>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label"> Document Type <span class="has-text-danger">*</span> </label>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select v-model="selectedDocType" required @change="docSelect">
                        <option value="" selected>-Select-</option>
                        <option value="addharCard">Aadhar Card</option>
                        <option value="panCard">Pan Card</option>
                        <option value="education">Educational Docs</option>
                        <option value="image">Image</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label" :class="selectedDocType === '' ? 'has-text-danger' : ''">
                    {{ inputTitle }}
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <b-field class="file is-primary">
                    <b-upload v-model="dropFile" required single class="file-label" :disabled="selectedDocType === ''" @input="onFilechange(selectedDocType)">
                      <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Click to upload</span>
                      </span>
                    </b-upload>
                  </b-field>
                  <span class="has-text-danger">{{ formatMsg }}</span>
                  <div class="tags" v-if="dropFile && dropFile.name">
                    <span class="tag is-primary">
                      {{ dropFile.name }}
                    </span>
                    <button class="delete is-small" type="button" @click="deleteDropFile('addharCard')"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-button title="download" :disabled="!urls.adhar" @click="downloadDoc(urls.adhar)" size="is-small" :class="urls.adhar?'is-success': 'is-danger'" :icon-left="urls.adhar?'checkbox-marked-circle': 'alert-circle'">
                  Aadhar Card
                </b-button>
                &nbsp;
                <b-button title="download" :disabled="!urls.pan" @click="downloadDoc(urls.pan)" size="is-small" :class="urls.pan?'is-success': 'is-danger'" :icon-left="urls.pan?'checkbox-marked-circle': 'alert-circle'">
                  Pan Card
                </b-button>
                &nbsp;
                <b-button title="download" :disabled="!urls.edu" @click="downloadDoc(urls.edu)" size="is-small" :class="urls.edu?'is-success': 'is-danger'" :icon-left="urls.edu?'checkbox-marked-circle': 'alert-circle'">
                  Educational Document's
                </b-button>
                &nbsp;
                <b-button title="download" :disabled="!urls.avatar" @click="downloadDoc(urls.avatar)" size="is-small" :class="urls.avatar?'is-success': 'is-danger'" :icon-left="urls.avatar?'checkbox-marked-circle': 'alert-circle'">
                  Image
                </b-button>
              </div>
            </div>
            <footer class="column has-text-right">
              <button class="button is-success" type="submit">Save</button>
            </footer>
          </card-component>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import CardComponent from '@/components/template/CardComponent'
import stores from '@/stores'
export default {
  name: 'StaffDocumentUpload',
  components: {
    CardComponent
  },
  data () {
    return {
      dropFile: null,
      inputTitle: '',
      selectedDocType: '',
      formatMsg: '',
      user: stores.user.me,
      urls: {
        adhar: '',
        pan: '',
        edu: '',
        avatar: ''
      }
    }
  },
  created () {
    this.docSelect()
    if (this.user.id) {
      this.getUserData(this.user.id)
    }
  },
  methods: {
    downloadDoc: async function (path) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${path}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    getUserData: async function (id) {
      try {
        let { data } = await http.get(`${constants.API_URL}/api/staff/${id}`)
        this.urls.adhar = data.userStaff.addharCardUrl
        this.urls.pan = data.userStaff.panCardUrl
        this.urls.edu = data.userStaff.educationalDocUrl
        this.urls.avatar = data.userStaff.imageUrl
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    save: async function () {
      this.loadingComponent = this.$buefy.loading.open()
      let formData = new FormData()
      formData.append('lastName', this.user.lastName)
      formData.append('firstName', this.user.firstName)
      formData.append('type', this.selectedDocType)
      formData.append('document', this.dropFile)

      try {
        const res = await http.post(`${constants.API_URL}/api/staff/${this.user.id}`, formData)
        this.okMsg(`Document uploaded successfully, ${res.data}`)
        this.resetInputs()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
      this.getUserData(this.user.id)
      this.loadingComponent.close()
    },
    resetInputs () {
      this.dropFile = null
      this.inputTitle = 'Kindly select document type from dropdown!'
      this.selectedDocType = ''
      this.formatMsg = ''
    },
    onFilechange (fileType) {
      if (fileType === 'addharCard' || fileType === 'panCard') {
        if (this.dropFile.type !== 'application/pdf' && this.dropFile.type !== 'image/jpeg') {
          this.errMsg('Kindly select only .pdf or .jpeg/.jpg format file!')
          this.deleteDropFile()
        }
      } else if (fileType === 'education') {
        if (this.dropFile.type !== 'application/pdf' && this.dropFile.type !== 'image/jpeg' && this.dropFile.type !== 'image/jpg' && this.dropFile.type !== 'image/png') {
          this.errMsg('Kindly select only .pdf or .jpeg/.jpg, .png format file!')
          this.deleteDropFile()
        }
      } else if (fileType === 'image') {
        if (this.dropFile.type !== 'image/jpeg') {
          this.errMsg('Kindly select only .jpeg/.jpg format file!')
          this.deleteDropFile()
        }
      }
    },
    deleteDropFile () {
      this.dropFile = [this.dropFile]
      this.dropFile.splice(0, 1)
    },
    docSelect () {
      this.inputTitle =
        this.selectedDocType === 'addharCard'
          ? 'Aadhar Card'
          : this.selectedDocType === 'panCard'
            ? 'Pan Card'
            : this.selectedDocType === 'education'
              ? "Educational Doc's"
              : this.selectedDocType === 'image'
                ? 'Image'
                : 'Kindly select document type from dropdown!'
      this.formatMsg =
        this.selectedDocType === 'addharCard' || this.selectedDocType === 'panCard'
          ? 'Only .pdf, .jpg/.jpeg format file'
          : this.selectedDocType === 'education'
            ? 'Only .pdf, .jpg/.jpeg, .png format file'
            : this.selectedDocType === 'image'
              ? 'Only .jpg/.jpeg format file'
              : ''
      this.dropFile = null
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style scoped>
.tag:not(body) {
  white-space: break-spaces;
  height: auto;
  min-height: 2em;
  flex: 1;
  margin-bottom: 0;
}
</style>
